import AdminVaspsTable from './AdminVaspsTable'

export default AdminVaspsTable
